import React, { useState, useEffect } from 'react';

const DEFAULTS = {
  enabled: true,
  interface: 'bridge1',
  address_pool: '10.0.0.50-10.0.0.200',
  dns_name: 'hotspot.local',
  rate_limit: '5M/10M',
  shared_users: '1',
  default_user: 'admin',
  default_password: '1234',
  walled_garden: [],
};

export default function StepHotspot({ data, onChange, onNext, onBack, interfaceNames }) {
  const [form, setForm] = useState(data || DEFAULTS);
  const [wgInput, setWgInput] = useState('');

  useEffect(() => {
    if (data) setForm(data);
  }, [data]);

  const update = (key, value) => {
    const updated = { ...form, [key]: value };
    setForm(updated);
    onChange(updated);
  };

  const addWg = () => {
    if (!wgInput.trim()) return;
    update('walled_garden', [...(form.walled_garden || []), wgInput.trim()]);
    setWgInput('');
  };

  const removeWg = (i) => {
    update('walled_garden', form.walled_garden.filter((_, idx) => idx !== i));
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">📶 ตั้งค่า Hotspot (หน้าล็อกอิน)</h2>
        <p className="text-gray-500 dark:text-gray-400">สร้าง Captive Portal ให้ผู้ใช้ล็อกอินก่อนใช้งานอินเทอร์เน็ต เหมาะสำหรับร้านกาแฟ โรงแรม โรงเรียน</p>
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="label">Interface</label>
            <select value={form.interface} onChange={e => update('interface', e.target.value)} className="input-field">
              {(interfaceNames && interfaceNames.length > 0 ? interfaceNames : ['bridge1', 'bridge-lan', 'ether1', 'ether2']).map(iface => (
                <option key={iface} value={iface}>{iface}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="label">ช่วง IP สำหรับ Hotspot</label>
            <input type="text" value={form.address_pool} onChange={e => update('address_pool', e.target.value)} className="input-field" placeholder="10.0.0.50-10.0.0.200" />
          </div>
        </div>
        <div>
          <label className="label">ชื่อโดเมน Hotspot</label>
          <input type="text" value={form.dns_name} onChange={e => update('dns_name', e.target.value)} className="input-field" placeholder="hotspot.local" />
          <p className="text-[10px] text-gray-400 mt-1">ชื่อที่ผู้ใช้จะเห็นในหน้าล็อกอิน</p>
        </div>
        <div>
          <label className="label">จำกัดความเร็ว (อัปโหลด/ดาวน์โหลด)</label>
          <input type="text" value={form.rate_limit} onChange={e => update('rate_limit', e.target.value)} className="input-field" placeholder="5M/10M" />
          <p className="text-[10px] text-gray-400 mt-1">เช่น 5M/10M = อัปโหลด 5Mbps, ดาวน์โหลด 10Mbps ต่อผู้ใช้</p>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label">👤 ชื่อผู้ใช้เริ่มต้น</label>
            <input type="text" value={form.default_user} onChange={e => update('default_user', e.target.value)} className="input-field" />
          </div>
          <div>
            <label className="label">🔒 รหัสผ่านเริ่มต้น</label>
            <input type="text" value={form.default_password} onChange={e => update('default_password', e.target.value)} className="input-field" />
          </div>
        </div>

        <div>
          <label className="label">🌐 Walled Garden (เว็บไซต์ที่เข้าได้โดยไม่ต้องล็อกอิน)</label>
          <div className="flex gap-2 mb-2">
            <input type="text" value={wgInput} onChange={e => setWgInput(e.target.value)} className="input-field text-sm flex-1" placeholder="เช่น payment.example.com" />
            <button onClick={addWg} className="btn-primary text-sm">เพิ่ม</button>
          </div>
          {form.walled_garden && form.walled_garden.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {form.walled_garden.map((wg, i) => (
                <span key={i} className="px-2.5 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-lg text-xs font-medium flex items-center gap-1.5">
                  {wg}
                  <button onClick={() => removeWg(i)} className="hover:text-red-500 transition-colors">×</button>
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="mt-4 p-3 bg-pink-50 dark:bg-pink-900/10 border border-pink-100 dark:border-pink-800/50 rounded-lg">
        <p className="text-xs text-pink-700 dark:text-pink-300">
          <strong>💡 เคล็ดลับ:</strong> Walled Garden ใช้สำหรับอนุญาตให้เข้าถึงเว็บไซต์สำคัญได้โดยไม่ต้องล็อกอิน เช่น หน้าชำระเงิน, เว็บไซต์ธนาคาร
        </p>
      </div>

      <div className="flex justify-between mt-6">
        <button onClick={onBack} className="btn-secondary">← ย้อนกลับ</button>
        <button onClick={onNext} className="btn-primary">ถัดไป</button>
      </div>
    </div>
  );
}
